import { HeroSection, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { LanguageSelectors, useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { AppSelectors } from '../app';
import { SKELETON_CLASSNAME } from '../base/constants';
import Day0Banner from '../d0banner/Day0Banner';
import { GroupAdminBanner } from '../groupAdmin';
import { IState } from '../store/state';
import DomainSection from './DomainSection';
import ExerciseSection from './ExerciseSection';
import LEDSection from './LEDSection';
import SpecialNeedsSection from './SpecialNeedsSection';
import { PersonalizationActions } from './slice';
import useUserIdFromRoute from './useUserIdFromRoute';

export const PersonalizationRoute = '/settings';

export interface IPersonalizationPageProps {
  loaded: boolean;
  onInitUser: typeof PersonalizationActions.initUser;
}

export const PersonalizationPageFC: React.FC<IPersonalizationPageProps> = ({ loaded, onInitUser }) => {
  const { t } = useTranslation();
  const userId = useUserIdFromRoute();
  const personalizationLottie = 'Lab_Animation360';
  const skeletonClass = loaded ? '' : SKELETON_CLASSNAME;
  const title = userId ? t('Personalization.UserTitle') : t('Personalization.Title');
  const intro = userId ? t('Personalization.UserIntro') : t('Personalization.Intro');
  React.useEffect(() => {
    if (!userId || !onInitUser) {
      return;
    }
    onInitUser(userId);
  }, [onInitUser, userId]);
  return (
    <>
      <Day0Banner />
      <HeroSection lottie={personalizationLottie} className="personalization-hero-section">
        <SectionTitle className={skeletonClass}>{title}</SectionTitle>
        <SectionSubtitle className={skeletonClass}>{intro}</SectionSubtitle>
      </HeroSection>
      <GroupAdminBanner userId={userId} />
      {/* disabled until we find a good way to handle it */}
      {/* <TrainingIntensity /> */}
      <DomainSection userId={userId} />
      <LEDSection userId={userId} />
      <SpecialNeedsSection userId={userId} />
      <ExerciseSection userId={userId} />
    </>
  );
};

const mapStateToProps = (state: IState) => {
  const appLoaded = !AppSelectors.isAppLoading(state);
  const langLoaded = !LanguageSelectors.isLoading(state);
  return {
    loaded: appLoaded && langLoaded,
  };
};

const mapDispatchToProps = {
  onInitUser: PersonalizationActions.initUser,
};

const Personalization = connect(mapStateToProps, mapDispatchToProps)(PersonalizationPageFC);

export default Personalization;
